import type { ContextBase, PathParamsBase } from "../endpoint/Endpoint.js";
import EndpointRouter from "../endpoint/EndpointRouter.js";
import buildAuthenticatedRouter from "./buildAuthenticatedRouter.js";
import buildBriefRouter from "./buildBriefRouter.js";
import buildCandidateRouter from "./buildCandidateRouter.js";
import buildContactRouter from "./buildContactRouter.js";
import buildIamRouter from "./buildIamRouter.js";
import buildJoinSessionRouter from "./buildJoinSessionRouter.js";
import buildMailingRouter from "./buildMailingRouter.js";
import buildProjectRouter from "./buildProjectRouter.js";
import buildUserRouter from "./buildUserRouter.js";

export default function buildApiRouter(base: EndpointRouter<PathParamsBase, ContextBase>) {
    const iam = buildIamRouter(base);
    const authenticated = buildAuthenticatedRouter(base);
    const project = buildProjectRouter(authenticated.router);
    const joinSession = buildJoinSessionRouter(project.router);
    const user = buildUserRouter(authenticated.router);
    const candidate = buildCandidateRouter(project.router);
    const contact = buildContactRouter(project.router);
    const brief = buildBriefRouter(authenticated.router);
    const mailing = buildMailingRouter(authenticated.router);

    const output = {
        router: base,
        iam,
        authenticated,
        project,
        joinSession,
        user,
        candidate,
        contact,
        brief,
        mailing,
    };
    return output;
}

export type ApiRouting = ReturnType<typeof buildApiRouter>;
